import {connect} from "react-redux";
import BaActivityList from "./list";
import {bindActionCreators} from "redux";
import {activityList} from "../../../../service/Activity/action";
import {addTaggedAlong} from "../../../../service/Dealer/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {isCheckout} from "../../../../service/CarService/action";
import {markAttendance, accountByLeadId} from "../../../../service/BA/action";
import {ratingSave} from "../../../../service/Dealer/action";
const mapStateToProps = (state) => ({
    activityListDetails: state.Activity.activityList,
    addedTaggedAlong: state.Dealer.addedTaggedAlong,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    isCheckoutDetails:state.CarService.isCheckout,
    attendance:state.BA.attendance,
    accountLeadId:state.BA.accountLeadId,
    savedRating: state.Dealer.savedRating,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            activityList,
            addTaggedAlong,
            documentUploadUrlPublic,
            isCheckout,
            markAttendance,
            accountByLeadId,
            ratingSave
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(BaActivityList);
